import { render } from "./RegisterAuthorButtonAndModal.vue?vue&type=template&id=b64fa6c2"
import script from "./RegisterAuthorButtonAndModal.vue?vue&type=script&lang=js"
export * from "./RegisterAuthorButtonAndModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__